/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LpInspectionDto } from '../../models/lp-inspection-dto';
import { UseCouponDto } from '../../models/use-coupon-dto';

export interface NonMemberControllerUse$Params {
  childId: string;
  code: string;
      body: UseCouponDto
}

export function nonMemberControllerUse(http: HttpClient, rootUrl: string, params: NonMemberControllerUse$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
  const rb = new RequestBuilder(rootUrl, nonMemberControllerUse.PATH, 'post');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.query('code', params.code, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LpInspectionDto>;
    })
  );
}

nonMemberControllerUse.PATH = '/api/non-member/coupon/use';
